import { COLUMN_SORT_STATES } from './store/constants'

const gridSortStates = {
  [COLUMN_SORT_STATES.asc]: 'asc',
  [COLUMN_SORT_STATES.desc]: 'desc',
  [COLUMN_SORT_STATES.none]: 'none',
}

export const stateSortToAgGrid = (stateSort) => gridSortStates[stateSort] || 'none'
